import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  ProductionCodeRequestListPayload,
  ProdukcioniKodIzvodPayload,
} from "./productionCode.types";

/**
 * Keys used to invalidate stored cached data regarding production code module
 */
export const productionCodeKeys = createQueryKeys("production_code", {
  productionCodeRequestList: ({
    filters,
  }: {
    filters: Partial<ProductionCodeRequestListPayload>;
  }) => ({
    queryKey: ["request_list", filters],
  }),
  produkcioniKodoviListaIzvoda: ({
    filters,
  }: {
    filters: Partial<ProdukcioniKodIzvodPayload>;
  }) => ({
    queryKey: ["produkcioni_kodovi_lista_izvoda", filters],
  }),
  formData: (tipObveznikaId: number | null) => ({
    queryKey: ["form_data", tipObveznikaId ?? undefined],
  }),
  productionCodeRequestDetails: (id: number | null) => ({
    queryKey: ["request_details", id ?? undefined],
  }),
});
